"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.endIconWrapper = exports.startIconWrapper = exports.StyledButton = exports.getButtonText = exports.getButtonBackground = exports.loadingClassName = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _core = require("@emotion/core");

var _eyemobileCore = _interopRequireDefault(require("@bit/eyemobile.core.constants"));

var _facepaint = _interopRequireDefault(require("facepaint"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mq = (0, _facepaint["default"])(['@media screen and (min-width: 375px)']);

var loadingClassName = function loadingClassName(theme) {
  return /*#__PURE__*/(0, _core.css)("width:18px;height:18px;margin-left:", theme && theme.getSpacing && theme.getSpacing(1, 'px') || '8px', ";");
};

exports.loadingClassName = loadingClassName;

var getButtonBackground = function getButtonBackground(_ref) {
  var theme = _ref.theme,
      color = _ref.color;

  if (!Object.prototype.hasOwnProperty.call(theme, 'getColor')) {
    return _eyemobileCore["default"]["default"];
  }

  return theme.getColor(color);
};

exports.getButtonBackground = getButtonBackground;

var getButtonText = function getButtonText(_ref2) {
  var theme = _ref2.theme,
      color = _ref2.color;

  if (!Object.prototype.hasOwnProperty.call(theme, 'getColor')) {
    return 'white';
  }

  return theme.getColor(color);
};

exports.getButtonText = getButtonText;

var getPadding = function getPadding(_ref3) {
  var theme = _ref3.theme;

  if (Object.prototype.hasOwnProperty.call(theme, 'getSpacing')) {
    return mq({
      paddingTop: [theme.getSpacing(1, 'px')],
      paddingBottom: [theme.getSpacing(1, 'px')],
      paddingLeft: [theme.getSpacing(2, 'px'), theme.getSpacing(3, 'px')],
      paddingRight: [theme.getSpacing(2, 'px'), theme.getSpacing(3, 'px')]
    });
  }

  return mq({
    paddingTop: [8],
    paddingBottom: [8],
    paddingLeft: [16, 24],
    paddingRight: [16, 24]
  });
};

var getFontSize = function getFontSize(_ref4) {
  var theme = _ref4.theme;

  if (Object.prototype.hasOwnProperty.call(theme, 'getSpacing')) {
    return mq({
      fontSize: [theme.getFontSize(0.8, 'px'), theme.getFontSize(1, 'px')]
    });
  }

  return mq({
    fontSize: [8, 12]
  });
};

var getVariantStyles = function getVariantStyles(_ref5) {
  var theme = _ref5.theme,
      color = _ref5.color,
      textColor = _ref5.textColor,
      variant = _ref5.variant;
  var buttonBackground = getButtonBackground({
    theme: theme,
    color: color
  });
  var buttonText = getButtonText({
    theme: theme,
    color: textColor
  });
  var variants = {
    "default": {
      backgroundColor: buttonBackground,
      border: 'none',
      color: buttonText
    },
    outlined: {
      backgroundColor: 'transparent',
      border: "1px solid ".concat(buttonBackground),
      color: buttonBackground
    },
    reversed: {
      backgroundColor: buttonText,
      border: 'none',
      color: buttonBackground
    }
  };
  return variants[variant] || variants["default"];
};

var StyledButton = (0, _styledBase["default"])("button", {
  target: "emybtvi0",
  label: "StyledButton"
})("min-width:auto;width:", function (_ref6) {
  var block = _ref6.block;
  return block ? '100%' : 'auto';
}, ";min-height:40px;display:flex;justify-content:center;align-items:center;outline:none;opacity:1;border-radius:20px;cursor:pointer;", getFontSize, " ", getPadding, ";font-family:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.getFont('futura');
}, ";text-transform:uppercase;white-space:nowrap;line-height:1;transition:color 0.15s ease-in-out,opacity 0.15s ease-in-out,background-color 0.15s ease-in-out;", function (props) {
  return getVariantStyles(props);
}, " &.selected{opacity:1;}&:disabled{opacity:0.5;pointer-events:none;cursor:default;}");
exports.StyledButton = StyledButton;

var startIconWrapper = function startIconWrapper(theme) {
  return /*#__PURE__*/(0, _core.css)("margin-right:", theme && theme.getSpacing ? theme.getSpacing(1, 'px') : '8px', ";line-height:0;font-size:0;");
};

exports.startIconWrapper = startIconWrapper;

var endIconWrapper = function endIconWrapper(theme) {
  return /*#__PURE__*/(0, _core.css)("margin-left:", theme && theme.getSpacing ? theme.getSpacing(1, 'px') : '8px', ";line-height:0;font-size:0;");
};

exports.endIconWrapper = endIconWrapper;

//# sourceMappingURL=Button.styles.js.map